// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes ellipsis-anim-15d105f1{0%{content:\"\"}33%{content:\".\"}66%{content:\"..\"}to{content:\"...\"}}.ellipsis[data-v-15d105f1]{display:inline-block;width:.75em;text-align:left;vertical-align:bottom}.ellipsis[data-v-15d105f1]:after{content:\".\";animation:ellipsis-anim-15d105f1 1.5s infinite}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
